export const rollbackOperationModalInitValue = {
  data: {
    confirmationText: '',
    operationTypeLabel: '',
    date: '',
    isRollBackConfirmed: false,
    isRollbackDisabled: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal: () => {},
    handleChangeConfirmationText: () => {},
    handleRollbackOperation: () => {},
  },
};
